import React from 'react';
import { Radio, RadioGroup, FormControlLabel } from '@mui/material';

const RadioGroupCustom = props => {
  const { member, isVE, onChange } = props;
  return (
    <RadioGroup
      value={member.value}
      className="radioGroup"
      onChange={e => {
        onChange(e);
      }}
    >
      {member?.domain?.elements?.map((val, i) => {
        return (
          <FormControlLabel
            key={i}
            value={val?.name}
            control={<Radio disabled={isVE} size="small" />}
            label={val?.description}
            className={val?.state == 'green' ? '' : 'gray-shade-option'}
          />
        );
      })}
    </RadioGroup>
  );
};
export default RadioGroupCustom;
